import {User as SessionUser} from 'firebase/auth'
import create from 'zustand'
import {Todo} from '../../models/Todo'
import {User as FirestoreUser} from '../../models/User'

export interface StoreProps {
  sessionUser: SessionUser | null
  user: FirestoreUser | null
  loadingSessionUser: boolean
  loadingUser: boolean
  loading: boolean
  currentSimulation: any | null
  todos: Todo[]
  protectedPath: string | null
  setLoading: (session: boolean, on?: boolean) => void
  setSessionUser: (user: SessionUser | null) => void
  setUser: (user: FirestoreUser | null) => void
  setCurrentSimulation: (currentSimulation: any | null) => void
  setTodos: (todos: Todo[]) => void
  setProtectedPath: (protectedPath: string | null) => void
}

export const sessionStore = create<StoreProps>((set, get) => ({
  sessionUser: null,
  user: null,
  loadingSessionUser: true,
  loadingUser: true,
  loading: true,
  currentSimulation: null,
  todos: [],
  protectedPath: null,
  setLoading: (session, on) => {
    const isOn = on !== false

    if (session) set({loadingSessionUser: isOn, loading: get().loadingUser || isOn})
    else set({loadingUser: isOn, loading: get().loadingSessionUser || isOn})
  },
  setSessionUser: user =>
    set({sessionUser: user, loadingSessionUser: false, loading: get().loadingUser}),
  setUser: user => set({user, loadingUser: false, loading: get().loadingSessionUser}),
  setCurrentSimulation: currentSimulation => set({currentSimulation}),
  setTodos: todos => set({todos}),
  setProtectedPath: protectedPath => set({protectedPath}),
}))
